import { AbstractObject } from './../core'

export default class AdAccountRoas extends AbstractObject {

  static get Field () {
    return Object.freeze({
      adgroup_id: 'adgroup_id',
      arpu_180d: 'arpu_180d',
      arpu_1d: 'arpu_1d',
      arpu_30d: 'arpu_30d',
      arpu_365d: 'arpu_365d',
      arpu_3d: 'arpu_3d',
      arpu_7d: 'arpu_7d',
      arpu_90d: 'arpu_90d',
      campaign_group_id: 'campaign_group_id',
      campaign_id: 'campaign_id',
      date_start: 'date_start',
      date_stop: 'date_stop',
      installs: 'installs',
      revenue: 'revenue',
      revenue_180d: 'revenue_180d',
      revenue_1d: 'revenue_1d',
      revenue_30d: 'revenue_30d',
      revenue_365d: 'revenue_365d',
      revenue_3d: 'revenue_3d',
      revenue_7d: 'revenue_7d',
      revenue_90d: 'revenue_90d',
      spend: 'spend',
      yield_180d: 'yield_180d',
      yield_1d: 'yield_1d',
      yield_30d: 'yield_30d',
      yield_365d: 'yield_365d',
      yield_3d: 'yield_3d',
      yield_7d: 'yield_7d',
      yield_90d: 'yield_90d'
    })
  }

  static get Fields () {
    return Object.freeze({
      adgroup_id: 'adgroup_id',
      arpu_180d: 'arpu_180d',
      arpu_1d: 'arpu_1d',
      arpu_30d: 'arpu_30d',
      arpu_365d: 'arpu_365d',
      arpu_3d: 'arpu_3d',
      arpu_7d: 'arpu_7d',
      arpu_90d: 'arpu_90d',
      campaign_group_id: 'campaign_group_id',
      campaign_id: 'campaign_id',
      date_start: 'date_start',
      date_stop: 'date_stop',
      installs: 'installs',
      revenue: 'revenue',
      revenue_180d: 'revenue_180d',
      revenue_1d: 'revenue_1d',
      revenue_30d: 'revenue_30d',
      revenue_365d: 'revenue_365d',
      revenue_3d: 'revenue_3d',
      revenue_7d: 'revenue_7d',
      revenue_90d: 'revenue_90d',
      spend: 'spend',
      yield_180d: 'yield_180d',
      yield_1d: 'yield_1d',
      yield_30d: 'yield_30d',
      yield_365d: 'yield_365d',
      yield_3d: 'yield_3d',
      yield_7d: 'yield_7d',
      yield_90d: 'yield_90d'
    })
  }

}
